import React, { useState, useEffect, useContext } from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { GiHamburgerMenu } from "react-icons/gi";
import SettingsPanelActor from './SettingsPanelActor';
import SettingsPanelCritic from './SettingsPanelCritic';
import SettingsPanelOperator from './SettingsPanelOperator';
import { Box, Typography, TextField, Select, MenuItem, Button, Checkbox, FormControlLabel } from "@mui/material";
import { AppContextisChecked } from '../context/AppContextisChecked';

export default function SlidingSidebar() {
  const [state, setState] = useState({ left: true });
  const [loop, setLoop] = useState(() => localStorage.getItem('loops') || 3);
  const { isChecked } = useContext(AppContextisChecked); // Detect isChecked from context
  // console.log('SlidingSlidebar *', isChecked);
  useEffect(() => {
    if (!localStorage.getItem('loops')) {
      localStorage.setItem('loops', '3');
      setLoop(3);
    }
  }, []);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) { return; }
    setState((prevState) => ({ ...prevState, [anchor]: open }));
  };

  const handleDoneClick = () => { setState({ left: false }); };
  const api_provider0 = ["Google Gemini", "Deepseek", "Anthropic"];
  const api_provider1 = ["Google Gemini", "Deepseek", "Anthropic"];
  const api_provider_operator = ["Google Gemini", "Deepseek", "Anthropic", "OpenAI"];
  const list = (anchor) => (
    <Box sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 350 }} role="presentation" onKeyDown={toggleDrawer(anchor, true)}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px" }}>
        <span style={{ fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: 600, fontSize: "20px", color: "black" }}>Settings</span>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {!isChecked && <span style={{ alignContent: "center", marginBottom: '-2px', fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: '750', letterSpacing: '0px', marginRight: '3px' }}>loops:</span>}
          {!isChecked && <span>
            <Select value={loop} onChange={(e) => { setLoop(e.target.value); localStorage.setItem(`loops`, e.target.value); }} fullWidth sx={{ backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "58px", height: "35px", paddingTop: '5px' }}>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((model) => (<MenuItem key={model} value={model}>{model}</MenuItem>))}
            </Select>
          </span>}
          <Button variant="contained" sx={{ backgroundColor: "#007bff", color: "#fff", fontSize: "13px", padding: "5px 15px", marginLeft: "10px", minWidth: "auto" }} onClick={handleDoneClick}>Done</Button>
        </div>
      </Box>
      {!isChecked && <div style={{ color: "transparent" }}>
        <List>
          {['Actor Model', 'Critic Model'].map((text, idx) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                {idx === 0 && <SettingsPanelActor name={text} idx={idx} api_provider={api_provider0} ai_agent={false} />}
                {idx === 1 && <SettingsPanelCritic name={text} idx={idx} api_provider={api_provider1} ai_agent={false} />}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </div>}
      {isChecked && <div style={{ color: "transparent" }}>
        <List>
          {['AI Agent Model'].map((text, idx) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                {idx === 0 && <SettingsPanelOperator name={text} idx={idx} api_provider={api_provider_operator} ai_agent={true}/>}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </div>}
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
        <div style={{ fontFamily: `"Arial"`, fontSize: "13px", marginLeft: "13px", marginRight: "15px", color: "rgb(75, 85, 99)" }}>If you have any questions or feedback, feel free to open an issue at https://github.com/sanyathoque/chainedLLM</div>
        <div style={{ fontFamily: `"Arial"`, fontSize: "13px", marginLeft: "13px", marginRight: "15px", color: "rgb(75, 85, 99)" }}>v3.2.6</div>
      </div>
    </Box>
  );

  return (
    <div>
      <Button onClick={toggleDrawer('left', true)}><GiHamburgerMenu style={{ height: "2.5vh", width: "2.5vw", color: "rgb(75, 85, 99)" }} /></Button>
      <Drawer anchor="left" open={state.left} onClose={toggleDrawer('left', false)}>{list('left')}</Drawer>
    </div>
  );
}